import {Controller} from "stimulus";
import {formatDistanceToNow} from "date-fns";

const INTERVAL_MS = 10_000;
const ONE_HOUR_MS = 3_600_000;

export default class TimeController extends Controller<HTMLTimeElement> {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  connect() {
    if (this.ageInMilliseconds < ONE_HOUR_MS) {
      this.updateContent();
      this.intervalId = setInterval(() => this.updateContent(), INTERVAL_MS);
    }
  }

  disconnect() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private updateContent() {
    const date = new Date(this.datetime);
    if (isNaN(date.getTime())) return;

    this.element.textContent = formatDistanceToNow(date, {addSuffix: true});
  }

  private get datetime() {
    return this.element.getAttribute("datetime") || "";
  }

  private get ageInMilliseconds() {
    return Math.abs(Date.now() - new Date(this.datetime).getTime());
  }
}
